import {
  SimpleGrid,
  Text,
  Input,
  FormControl,
  FormLabel,
  VStack,
  Button,
  HStack,
  Center,
  Stack,
  Image,
  Link,
  Box,
} from "@chakra-ui/react";
//import { ReactNode } from "react";
import { NavLink as ReachLink } from "react-router-dom";
import Logo from "../../static/CUC_LOGO_NEW_MIN.svg";
import FacebookLogo from "../../images/footer/facebook.svg";
import InstagramLogo from "../../images/footer/instagram.svg";
import WhatsappLogo from "../../images/footer/whatsapp.svg";
import TelefonoLogo from "../../images/footer/telefono.svg";
import UbicacionLogo from "../../images/footer/ubicacion.svg";
import EmailLogo from "../../images/footer/email.svg";
import "./style.css";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();

  return (
    <>
      <Center bg="gray.900" fontFamily={"Oswald"}>
        <SimpleGrid
          columns={{ base: 1, sm: 1, md: 3 }}
          color="white"
          ml={{ base: "60px", sm: 8, md: 0 }}
          py={{ base: 10, sm: 4, md: 10 }}
          w="1600px"
          spacing={10}
        >
          <VStack
            maxW="200px"
            m={{ base: 2, sm: 10, md: "auto" }}
            mb={{ base: 2, sm: 4 }}
          >
              <FormControl isRequired>
                <FormLabel mb={-0.5}>{t("footer.form.nameLabel")}</FormLabel>
                <Input
                  mb={2}
                  name="contact_name"
                  type="text"
                  size="sm"
                  variant="unstyled"
                  placeholder={t("footer.form.namePlaceholder")}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel mb={-0.5}>{t("footer.form.emailLabel")}</FormLabel>
                <Input
                  mb={2}
                  name="contact_email"
                  type="email"
                  size="sm"
                  variant="unstyled"
                  placeholder={t("footer.form.emailPlaceholder")}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel mb={-0.5}>{t("footer.form.messageLabel")}</FormLabel>
                <Input
                  mb={2}
                  name="contact_message"
                  type="text"
                  size="sm"
                  variant="unstyled"
                  placeholder={t("footer.form.messagePlaceholder")}
                />
              </FormControl>
              <Button
                className="cuc-section-btn"
                bg={"blue.400"}
                color={"white"}
                borderRadius={0}
                _hover={{
                  bg: "blue.600",
                }}
                fontWeight={400}
                size="sm"
                width="100%"
              >
                {t("footer.form.sendButton")}
              </Button>
          </VStack>

          <Stack
            spacing={5}
            mx={{ base: 2, sm: 10, md: "auto" }}
            textAlign="left"
            fontWeight={300}
            mt={1}
          >
            <HStack spacing={4} className="footer-links">
              <Box w="20px">
                <Image
                  m="auto"
                  src={TelefonoLogo}
                  width="18px"
                  height="18px"
                  alt={t("footer.alt.phone")}
                />
              </Box>

              <a
                href="https://wa.me/34674088825"
                target="_blank"
                rel="noreferrer"
              >
                <Text>+34 674 088 825</Text>
              </a>
            </HStack>
            <HStack spacing={4} className="footer-links">
              <Box w="20px">
                <Image
                  m="auto"
                  src={UbicacionLogo}
                  width="16px"
                  height="23px"
                  alt={t("footer.alt.location")}
                />
              </Box>
              <a
                href="https://goo.gl/maps/wiwarSmDqsMRfiAc8"
                target="_blank"
                rel="noreferrer"
              >
                <Text>{t("footer.address")}</Text>
              </a>
            </HStack>
            <HStack spacing={4}>
              <Box w="20px">
                <Image
                  m="auto"
                  src={EmailLogo}
                  width="20px"
                  height="16px"
                  alt={t("footer.alt.email")}
                  mt={1}
                />
              </Box>
              <Text>hola@cucfitness.com</Text>
            </HStack>

            <HStack pt={4} spacing={7}>
              <a
                href="https://wa.me/34674088825"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={WhatsappLogo}
                  width="40px"
                  height="40px"
                  alt={t("footer.alt.whatsapp")}
                />
              </a>
              <a
                href="https://www.facebook.com/cucfitness/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={FacebookLogo}
                  width="40px"
                  height="40px"
                  alt={t("footer.alt.facebook")}
                />
              </a>
              <a
                href="https://www.instagram.com/cucfitness/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={InstagramLogo}
                  width="40px"
                  height="40px"
                  alt={t("footer.alt.instagram")}
                />
              </a>
            </HStack>
          </Stack>

          <Stack
            textAlign="left"
            m={{ base: 2, sm: 10, md: "auto" }}
            mt={{ base: 2, sm: 4 }}
            className="footer-links"
          >
            <Stack spacing={-0.5} mb={1}>
              <Link as={ReachLink} to="/about" fontWeight="400">
                {t("footer.links.about")}
              </Link>
              <Link as={ReachLink} to="/careers" fontWeight="400">
                {t("footer.links.careers")}
              </Link>
            </Stack>

            <Stack spacing={-0.5} fontWeight={300}>
              <Link as={ReachLink} to="/cookies">
                {t("footer.links.cookies")}
              </Link>
              <Link as={ReachLink} to="/privacy">
                {t("footer.links.privacy")}
              </Link>
              <Link as={ReachLink} to="/terms">
                {t("footer.links.terms")}
              </Link>
            </Stack>

            <Stack textAlign="left" pt={2}>
              <Image
                src={Logo}
                width="52px"
                height="52px"
                ml={-0.5}
                alt={t("footer.alt.logo")}
              />
              <Text fontSize="10px" fontWeight={300}>
                © {new Date().getFullYear()} {t("footer.brand")}
              </Text>
            </Stack>
          </Stack>
        </SimpleGrid>
      </Center>
    </>
  );
}
